export default "<button *ngIf=\"logs.length > 0\" mat-fab color=\"accent\" class=\"sticky\" (click)=\"openDialog()\">Debug</button>";